const mobile_breakpoint = 768;

let activeOverlayCard = null;
let activeSourceCard = null;

document.addEventListener("DOMContentLoaded", async () => {
    await loadMembers();
});

async function loadMembers() {
    const grid = document.getElementById("team-grid");

    if (!grid) {
        console.error("Team grid not found.");
        return;
    }
    const template = document.getElementById("team-card-template");

    if (!template) {
        console.error("Team template not found.");
        return;
    }
    const jsonUrl = grid.dataset.jsonUrl;

    if (!jsonUrl) {
        console.error("JSON URL missing.");
        return;
    }

    let assetBaseUrl = grid.dataset.jsonUrl.replace("team.json", "");
    assetBaseUrl = assetBaseUrl.split("?")[0].replace(/\/[^\/]*$/, "/");

    const overlay = grid.querySelector(".team-grid__overlay");

    try {
        const response = await fetch(jsonUrl);

        if (!response.ok) {
            throw new Error("Unable to load team.json");
        }

        const members = await response.json();

        members.forEach((member, index) => {
            const clone = template.content.cloneNode(true);
            const card = clone.querySelector(".team-card");
            card.dataset.memberIndex = index;

            // Image and details
            const image = clone.querySelector(".team-card__image");

            image.src = `${assetBaseUrl}${member.image}`;
            image.alt = member.name;

            clone.querySelector(".team-card__name").textContent = member.name || "";
            clone.querySelector(".team-card__role").innerHTML = member.role || "&nbsp;";
            clone.querySelector(".team-card__phone").textContent = member.phone || "";

            // Button links
            const linkedin = clone.querySelector(".team-card__icon--linkedin");
            if (member.linkedin) {
                linkedin.href = member.linkedin;
            } else {
                linkedin.remove();
            }

            const phone = clone.querySelector(".team-card__icon--phone");
            if (member.phone) {
                phone.href =
                    `tel:${member.phone.replace(/\s+/g, "")}`;
            } else {
                phone.remove();
            }

            const email = clone.querySelector(".team-card--email");
            if (member.email) {                
                const email_link = email.querySelector("a");
                if (email_link) {
                    email_link.innerHTML = member.email;
                    email_link.href = `mailto:${member.email}`;
                } else {
                    email.innerHTML = member.email;
                }
            } else {
                email.remove();
            }

            // Stop links from opening member
            clone.querySelectorAll(".team-card__icon, .team-card--email").forEach(icon => {
                icon.addEventListener("click", e => {
                    e.stopPropagation();
                });

            });

            // Extension Details
            const extension = clone.querySelector(".team-card__extension");
            extension.innerHTML = "content";

            if (member.questions && member.questions.length) {
                extension.innerHTML = member.questions.map(item => `
                    <div class="team-card__question">
                        <h4 class="team-card__question-title">
                            ${item.question}
                        </h4>
                        <p class="team-card__question-answer">
                            ${item.answer}
                        </p>
                    </div>
                `).join("");
            } else {
                extension.innerHTML = "<p>Nothing to display here</p>";
            }

            // Click
            card.addEventListener("click", () => {
                openMember(card);
            });

            grid.appendChild(clone);

        });

        
        /* Close when clicking outside */
        document.addEventListener("click", e => {

            if (!activeOverlayCard) {
                return;
            }

            if (
                !activeOverlayCard.contains(e.target) &&
                !activeSourceCard.contains(e.target)
            ) {
                closeMember();
            }

        });
    } catch(error) {
        console.error(error);

        grid.innerHTML = `
            <p class="team-error">
                Unable to load the team information.
            </p>
        `;
    }
}

function openMember(card) {
    const grid = document.querySelector(".team-grid");
    //const overlay = grid.querySelector(".team-grid__overlay");
    const overlay = document.querySelector(".team-grid__overlay");

    closeMember();

    // If Mobile just display extension (nothing fancy)
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (screenWidth < mobile_breakpoint) {
        const extension = card.querySelector(".team-card__extension");

        if (extension) {
            extension.style.display = "block";
        }
        return;
    }

    activeSourceCard = card;

    const clone = card.cloneNode(true);
    clone.classList.add("team-card--overlay");
    overlay.appendChild(clone);

    activeOverlayCard = clone;
    
    // Get original position
    const cardRect = card.getBoundingClientRect();
    const gridRect = grid.getBoundingClientRect();

    const start = {
        top: cardRect.top - gridRect.top,
        left: cardRect.left - gridRect.left,
        width: cardRect.width,
        height: cardRect.height
    };
    
    // Set starting position
    clone.style.top = `${start.top}px`;
    clone.style.left = `${start.left}px`;
    clone.style.width = `${start.width}px`;
    clone.style.height = `${start.height}px`;

    // Force browser paint
    clone.offsetHeight;

    // Decide direction 
    const column = getColumn(card, grid);

    if (column === 3) {
        clone.classList.add("expand-left");
    } else {
        clone.classList.add("expand-right");
    }

    // Animate to full width 
    const targetWidth = gridRect.width - 24;
    clone.style.width = `${targetWidth}px`;
    clone.style.height = `${cardRect.height}px`;
    clone.style.left = `${12}px`; 

    // Give close btn its event
    const closeButton = clone.querySelector(".team-card__close");

    if (closeButton) {
        closeButton.addEventListener("click", e => {
            e.stopPropagation();
            closeMember();
        });
    }

    // Move extension into view 
    const extension = clone.querySelector(".team-card__extension");

    if (extension) {
        extension.style.display = "block";
    }
}

function closeMember() {
    const extensions = document.querySelectorAll(".team-card__extension");
    extensions.forEach(function(extension) {
        extension.style.display = "none";
    })    
    
    if (!activeOverlayCard) {
        return;
    }

    activeOverlayCard.remove();
    activeOverlayCard = null;
    activeSourceCard = null;
}

function getColumn(card, grid) {
    const cards = [...grid.querySelectorAll(".team-card-wrapper")];

    const index = cards.findIndex(wrapper =>
        wrapper.contains(card)
    );
    return (index % 3) + 1;

}

// Hide overlay / extra on window resize as overlay is not reactive
let lastWidth = window.innerWidth; // Solve of iphone / safari triggering onresize event when scroll.
window.onresize = function() {
    if (Math.abs(window.innerWidth - lastWidth) > 5) { // With buffer to catch edge cases
        lastWidth = window.innerWidth;
        closeMember();
    }
};